import React from "react";
import { Col, Row } from "react-bootstrap";
import Tweet from "../Components/BottomHomePage/Tweet";
import Header from "../Components/HomePage/Header";
import Navbar from "../Components/HomePage/Navbar";
import Pic from "../Components/HomePage/Pic";
import ComingStories from "../Components/BottomHomePage/ComingStories";
import Rights from "../Components/BottomHomePage/Rights";
import Transgenders from "../Components/BottomHomePage/Transgenders";
import Women from "../Components/BottomHomePage/Women";
import Footer from "../Components/BottomHomePage/Footer";
function HomePage() {
  return (
    <>
      <div className="home-page">
        <Header />
        <Navbar />
        <Pic />
        <Tweet />
        <ComingStories />
        <Rights />
        <Transgenders />
        <Women />
        <Footer/>
      </div>
    </>
  );
}

export default HomePage;
